export const FETCH_TRANSACTION_STATUS_BEGIN='FETCH_TRANSACTION_STATUS_BEGIN';
export const FETCH_TRANSACTION_STATUS_SUCCESS='FETCH_TRANSACTION_STATUS_SUCCESS';
export const FETCH_TRANSACTION_STATUS_FAILURE='FETCH_TRANSACTION_STATUS_FAILURE';

export const FETCH_ASSETLOT_PLAIN_BEGIN='FETCH_ASSETLOT_PLAIN_BEGIN';
export const FETCH_ASSETLOT_PLAIN_SUCCESS='FETCH_ASSETLOT_PLAIN_SUCCESS';
export const FETCH_ASSETLOT_PLAIN_FAILURE='FETCH_ASSETLOT_PLAIN_FAILURE';

export const FETCH_TRANSACTION_ASSETBYTYPE_BEGIN='FETCH_TRANSACTION_ASSETBYTYPE_BEGIN';
export const FETCH_TRANSACTION_ASSETBYTYPE_SUCCESS='FETCH_TRANSACTION_ASSETBYTYPE_SUCCESS';
export const FETCH_TRANSACTION_ASSETBYTYPE_FAILURE='FETCH_TRANSACTION_ASSETBYTYPE_FAILURE';
